import { t } from "@/i18n-js/instance";
import { FormTipTapEditor } from "@/react/components/shared/BuilderUI/Editor/fields/RichTextField/FormTiptapEditor";
import { Form } from "@circle-react-uikit/Form";

export const ContentEditor = () => (
  <div className="px-6">
    <Form.Item
      name="text"
      label={t("builder_ui.prop_type.text")}
      hideBorder
      hideDescription
    >
      <FormTipTapEditor name="text" />
    </Form.Item>
    <Form.Item
      name="href"
      label={t("builder_ui.prop_type.link")}
      hideBorder
      hideDescription
    >
      <Form.Input name="href" data-testid="builder-ui-href-input" />
    </Form.Item>
  </div>
);
